import { buildApiUrl } from '../../../config/api';
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import '../VentasAdmin.css';

const RecuperaVenta = ({ token, onVentaRecuperada }) => {
  const [ventas, setVentas] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [filtroEstado, setFiltroEstado] = useState('REPORTADO');
  const [showRecuperarModal, setShowRecuperarModal] = useState(false);
  const [ventaSeleccionada, setVentaSeleccionada] = useState(null);
  const [formData, setFormData] = useState({
    fechaRecupera: new Date().toISOString().split('T')[0],
    estadoServicio: 'PENDIENTE', // Cambiar de 'INSTALADO' a 'PENDIENTE'
    observaciones: ''
  });

  useEffect(() => {
    fetchVentasRecuperar();
  }, [currentPage, filtroEstado]);



  const fetchVentasRecuperar = async () => {
    setLoading(true);
    setError('');
    
    try {
      const params = {
        page: currentPage,
        limit: 20,
        estado: filtroEstado
      };

      console.log('🔍 Iniciando petición...');
      console.log('URL:', 'http://localhost:4000/api/ventas/recuperar');
      console.log('Parámetros:', params);
      console.log('Token presente:', !!token);

      const response = await axios.get(buildApiUrl('/api/ventas/recuperar'), {
        headers: { Authorization: `Bearer ${token}` },
        params
      });

      console.log('✅ Respuesta exitosa:', response.data);
      console.log('Ventas encontradas:', response.data.ventas?.length || 0);

      setVentas(response.data.ventas || []);
      setTotalPages(response.data.totalPages || 1);
      
      // Si no hay ventas, mostrar mensaje informativo
      if (!response.data.ventas || response.data.ventas.length === 0) {
        setError(`No hay ventas con estado "${filtroEstado}" para recuperar. Intenta con otro estado o verifica que existan ventas con estados REPORTADO, PENDIENTE o NO EXISTE.`);
      } else {
        setError(''); // Limpiar cualquier error anterior
      }
    } catch (err) {
      console.error('❌ Error en la petición:', err);
      
      if (err.response) {
        console.error('Status:', err.response.status);
        console.error('Data:', err.response.data);
        
        if (err.response.status === 401) {
          setError('Error de autenticación. Por favor, inicia sesión nuevamente.');
        } else if (err.response.status === 404) {
          setError('El endpoint no existe. Verifica que el backend esté actualizado.');
        } else {
          setError(`Error del servidor (${err.response.status}): ${err.response.data.error || err.response.statusText}`);
        }
      } else if (err.request) {
        console.error('No se recibió respuesta del servidor');
        setError('No se pudo conectar con el servidor. Verifica que el backend esté ejecutándose en http://localhost:4000');
      } else {
        console.error('Error en la configuración:', err.message);
        setError('Error de configuración: ' + err.message);
      }
    } finally {
      setLoading(false);
    }
  };

  const handleRecuperar = (venta) => {
    setVentaSeleccionada(venta);
    setFormData({
      fechaRecupera: new Date().toISOString().split('T')[0],
      estadoServicio: venta.estado_venta || 'PENDIENTE', // Usar el estado actual de la venta
      observaciones: ''
    });
    setShowRecuperarModal(true);
  };

  const handleSubmitRecuperar = async (e) => {
    e.preventDefault();
    try {
      await axios.post(buildApiUrl('/api/ventas/${ventaSeleccionada.id}/recuperar'), formData, {
        headers: { Authorization: `Bearer ${token}` }
      });
      
      setShowRecuperarModal(false);
      fetchVentasRecuperar(); // Recargar la lista
      alert('Venta recuperada exitosamente');
      
      // Llamar al callback para actualizar otros componentes
      if (onVentaRecuperada) {
        onVentaRecuperada();
      }
    } catch (err) {
      alert('Error al recuperar la venta');
      console.error('Error:', err);
    }
  };

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const getEstadoClass = (estado) => {
    const estados = {
      'REPORTADO': 'estado-reportado',
      'PENDIENTE': 'estado-pendiente',
      'NO EXISTE': 'estado-no-existe',
      'INSTALADO': 'estado-instalado',
      'ANULADO': 'estado-anulado',
      'DUPLICADO': 'estado-duplicado'
    };
    return estados[estado] || 'estado-venta';
  };

  return (
    <div className="ventas-admin-container">
      <h2>Recuperar Ventas</h2>
      <p className="descripcion">
        Listado de ventas con diferentes estados que requieren recuperación o actualización de estado.
      </p>
      
      {/* Filtro por estado */}
      <div className="filtros-container">
        <div className="filtro-item">
          <label>Filtrar por Estado:</label>
          <select
            value={filtroEstado}
            onChange={(e) => setFiltroEstado(e.target.value)}
            className="estado-select"
          >
            <option value="REPORTADO">REPORTADO</option>
            <option value="PENDIENTE">PENDIENTE</option>
            <option value="NO EXISTE">NO EXISTE</option>
            <option value="INSTALADO">INSTALADO</option>
            <option value="ANULADO">ANULADO</option>
            <option value="DUPLICADO">DUPLICADO</option>
          </select>
        </div>
        <button onClick={fetchVentasRecuperar} className="btn-filtrar">
          Filtrar
        </button>
      </div>

      {error && <div className="error-message">{error}</div>}

      {loading ? (
        <div className="loading">Cargando ventas para recuperar...</div>
      ) : ventas.length === 0 && !error ? (
        <div className="no-data-message">
          <p>No hay ventas con estado <strong>{filtroEstado}</strong> para recuperar.</p>
          <p>Intenta cambiar el filtro de estado o verifica que existan ventas con estados REPORTADO, PENDIENTE o NO EXISTE.</p>
        </div>
      ) : (
        <>
          <table className="ventas-table">
            <thead>
              <tr>
                <th>Vendedor</th>
                <th>Cliente</th>
                <th>Producto</th>
                <th>Monto</th>
                <th>Fecha</th>
                <th>Estado</th>
                <th>Acciones</th>
              </tr>
            </thead>
            <tbody>
              {ventas.map((venta) => (
                <tr key={venta.id}>
                  <td>{venta.vendedor}</td>
                  <td>{venta.cliente}</td>
                  <td>{venta.producto}</td>
                  <td>S/ {venta.precio}</td>
                  <td>{new Date(venta.fecha_venta).toLocaleDateString()}</td>
                  <td>
                    <span className={`estado-venta ${getEstadoClass(venta.estado_venta)}`}>
                      {venta.estado_venta}
                    </span>
                  </td>
                  <td>
                    <button
                      onClick={() => handleRecuperar(venta)}
                      className="btn-recuperar"
                    >
                      Recuperar
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          {/* Paginación */}
          {totalPages > 1 && (
            <div className="pagination">
              <button
                onClick={() => setCurrentPage(currentPage - 1)}
                disabled={currentPage === 1}
              >
                Anterior
              </button>
              <span>Página {currentPage} de {totalPages}</span>
              <button
                onClick={() => setCurrentPage(currentPage + 1)}
                disabled={currentPage === totalPages}
              >
                Siguiente
              </button>
            </div>
          )}
        </>
      )}

      {/* Modal Recuperar */}
      {showRecuperarModal && (
        <div className="modal-overlay">
          <div className="modal-content recuperar-venta-modal">
            <h3>Recuperar Venta</h3>
            
            {/* Datos de la venta (bloqueados) */}
            <div className="venta-details">
              <h4>Datos de la Venta</h4>
              <div className="detail-item">
                <strong>Vendedor:</strong> {ventaSeleccionada?.vendedor}
              </div>
              <div className="detail-item">
                <strong>Cliente:</strong> {ventaSeleccionada?.cliente}
              </div>
              <div className="detail-item">
                <strong>Producto:</strong> {ventaSeleccionada?.producto}
              </div>
              <div className="detail-item">
                <strong>Monto:</strong> S/ {ventaSeleccionada?.precio}
              </div>
              <div className="detail-item">
                <strong>Fecha:</strong> {ventaSeleccionada?.fecha_venta ? new Date(ventaSeleccionada.fecha_venta).toLocaleDateString() : ''}
              </div>
            </div>

            {/* Formulario de recuperación */}
            <form onSubmit={handleSubmitRecuperar}>
              <div className="form-group">
                <label>Fecha de Recupera:</label>
                <input
                  type="date"
                  name="fechaRecupera"
                  value={formData.fechaRecupera}
                  onChange={handleInputChange}
                  required
                  readOnly
                />
              </div>
              <div className="form-group">
                <label>Estado Servicio:</label>
                <select
                  name="estadoServicio"
                  value={formData.estadoServicio}
                  onChange={handleInputChange}
                  required
                  className="estado-select"
                >
                  <option value="INSTALADO">INSTALADO</option>
                  <option value="REPORTADO">REPORTADO</option>
                  <option value="PENDIENTE">PENDIENTE</option>
                  <option value="ANULADO">ANULADO</option>
                  <option value="DUPLICADO">DUPLICADO</option>
                  <option value="NO EXISTE">NO EXISTE</option>
                </select>
              </div>
              <div className="form-group">
                <label>Observaciones:</label>
                <textarea
                  name="observaciones"
                  value={formData.observaciones}
                  onChange={handleInputChange}
                  rows="4"
                  maxLength="2000"
                  placeholder="Escriba las observaciones de la recuperación..."
                  className="observaciones-textarea"
                />
                <small className="char-count">
                  {formData.observaciones.length}/2000 caracteres
                </small>
              </div>
              <div className="modal-buttons">
                <button type="submit" className="btn-guardar">
                  Grabar Recuperación
                </button>
                <button
                  type="button"
                  onClick={() => setShowRecuperarModal(false)}
                  className="btn-cancelar"
                >
                  Cancelar
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default RecuperaVenta; 